import React from 'react'
import { Link } from 'react-router-dom'
import { getSrc } from 'utils/image'

const Bubbles = () => (
  <React.Fragment>
    <div className="bubble pink-bubble" />
    <div className="bubble green-bubble" />
    <div className="bubble blue-bubble" />
  </React.Fragment>
)

export default ({ children, title, linkText, linkTo }) => {
  return (
    <div className="auth-background">
      <div className="background">
        <div className="container-image">
          <img className="desktop-image" alt="auth background" src={getSrc('/images/login-desktop.png')} />
          <img className="mobile-image" alt="auth background" src={getSrc('/images/login-mobile.png')} />
          <Bubbles />
        </div>
      </div>
      <div className="wrapper">
        <div className="content">
          <img alt="gipsybot animated-logo" className="animated-logo" src={getSrc('/images/welcome_screen_logo.gif')} />
          <img alt="gipsybot fixed-logo" className="fixed-logo" src={getSrc('/images/gb_horizontal_rgb.svg')} />
          <h1 className="title">{title}</h1>
          {children}
          {linkText && (
            <Link className="link" to={linkTo}>
              {linkText}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/auth/components/background/index.js